export const enum TypeCreditsEnum {
  PaymentCheck = 1,
  PaymentOnline = 2,
  PaymentCreditCard = 3,
  RevenueAdjustment = 4,
  ContractualAllowance = 5,
  Offset = 6,
  Refund = 7,
  WriteOffByManagement = 8,
  Mileage = 15,
  Denials = 19,
}



// WEBPACK FOOTER //
// ./src/app/core/enums/type-credits.enum.ts